/**
 *
 * Accessibility FontSize Changer (Vergrößerung und Verkleinerung vom Schrift (vom - ist polnisch))
 *
 * Accessibility FontSize Changer fügt eine Funktion zur Vergrößerung und Verkleinerung der Schrift hinzu. Die
 * Eingabe wird im Cookie zwischengespeichert, bis der Benutzer den Browser/Session schliesst.
 *
 * Event: document.ready
 *
 * @param {string} selectorInjection - Selector in dem die Buttons eingefügt werden
 * @return {undefined}
 *
 * @todo andere Lösung für selectorInjection finden. Precompiler Ticket: https://pm.lc-dev.de/browse/NETZCDEV-197
 *
 **/
function nc_initAccessibilityFontSizeChanger(selectorInjection) {
    var moduleLogger = LoggerManager.get('font-size-changer').setPrefix('SelectorInjection: ' + selectorInjection);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_accessibilityFontSizeChanger(selectorInjection);
    });
    moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initFontAccessibility
 * @param selectorInjection {string}
 */
function nc_accessibilityFontSizeChanger(selectorInjection) {

    /**
     * Logger
     */
    var moduleLogger = LoggerManager.get('font-size-changer').setPrefix('SelectorInjection: ' + selectorInjection);
    moduleLogger.trace('SCRIPT START');

    /**
     * Klassen der zu verwendenen Buttons
     * @type {{minus: string, reset: string, plus: string}}
     */
    var buttonClasses = {
        minus: 'font-size-toggler-minus',
        reset: 'font-size-toggler-reset',
        plus: 'font-size-toggler-plus',
    };

    /**
     * Wird bei der Initialisierung gefüllt mit den Selektoren der oben genannten Klassen
     * @type {{}}
     */
    var buttonSelectors = {};

    /**
     * Die aktuelle Schriftgröße
     * Wird aus dem Cookie oder mit dem Standard gefüllt
     * @type null|number
     */
    var currentFontSize;

    /**
     * Mögliche Font Sizes (% auf HTML)
     * Standard-Wert ist der erste Eintrag.
     * FontSizes müssen aufsteigend sein.
     * @type {number[]}
     */
    var fontSizes = [
        100,
        120,
        150,
        180,
        200,
    ];


    /**
     * Erhöht die FontSize (in Relation zur aktuellen FontSize)
     * @return {boolean}
     */
    function increaseFontSize() {
        moduleLogger.info('FontSize erhöhen');
        var newFontSizeKey = fontSizes.indexOf(getCurrentFontSize()) + 1;
        if (typeof fontSizes[newFontSizeKey] === 'undefined') {
            moduleLogger.error('FontSize konnte nicht erhöht werden. CurrentFontSize:' + getCurrentFontSize(), fontSizes);
            return false;
        }
        setCurrentFontSize(fontSizes[newFontSizeKey]);
        return true;
    }


    /**
     * Verringert die FontSize (in Relation zur aktuellen FontSize)
     * @return {boolean}
     */
    function decreaseFontSize() {
        moduleLogger.info('FontSize verringern');
        var newFontSizeKey = fontSizes.indexOf(getCurrentFontSize()) - 1;
        if (typeof fontSizes[newFontSizeKey] === 'undefined') {
            moduleLogger.error('FontSize konnte nicht verringert werden. CurrentFontSize:' + getCurrentFontSize(), fontSizes);
            return false;
        }
        setCurrentFontSize(fontSizes[newFontSizeKey]);
        return true;
    }

    /**
     * Initialisiert die aktuelle FontSize
     * Es wird versucht den Wert aus einem Cookie auszulesen und zu setzen
     * Oder es wird der Standard Wert gesetzt
     */
    function initCurrentFontSize() {
        moduleLogger.info('initCurrentFontSize: Aktuelle FontSize wird intialisiert');
        // Ist ein Wert im Cookie gesetzt?
        var cookieValue = getCookieValue();
        // Wenn nicht null, dann setzen
        if (cookieValue !== null) {
            setCurrentFontSize(cookieValue);
        } else { // ansonsten Standard setzen
            resetFontSize();
        }
    }

    /**
     * Gibt die aktuelle FontSize zurück.
     * @return {number}
     */
    function getCurrentFontSize() {
        return currentFontSize;
    }

    /**
     * Setzt die aktuelle FontSize, speichert diese im Cookie und ändert die fontSize von HTML per CSS
     * Es werden außerdem je nach FontSize Buttons auf disabled gesetzt, so dass man nicht außerhalb der verfügbaren
     * Größen klicken kann
     * @param fontSize {number|string}
     * @return {boolean}
     */
    function setCurrentFontSize(fontSize) {
        // Sicherstellen, dass die FontSize ein Int ist
        fontSize = parseInt(fontSize);
        // Key des Arrays für die gewünschte fontSize
        var newFontSizeKey = fontSizes.indexOf(fontSize);
        // Falls es den Wert nicht gibt / die neue fontSize nicht gültig ist
        if (newFontSizeKey === -1) {
            // Keine valide FontSize, also Reset
            moduleLogger.error('Gewünschte FontSize existiert nicht: ' + fontSize, fontSizes);
            resetFontSize();
            // Aus Funktion springen
            return false;
        }

        // Im Cookie speichern
        setCookieValue(fontSize);
        // In der Variable speichern
        currentFontSize = fontSize;
        moduleLogger.info('FontSize gesetzt: ' + fontSize, fontSizes);
        // Font size aufs Element setzen
        $('html').css('font-size', fontSize + '%');
        moduleLogger.info('FontSize CSS gesetzt: ' + fontSize + '%');
        // Resize Event triggern, da sich bestimmt einiges im Inhalt / Größe ändert

        // Buttons anpassen
        if (newFontSizeKey === 0) {
            // Erstes Array-Element = kleinste fontSize
            moduleLogger.info('FontSize ist kleinster Wert: ' + fontSize, fontSizes);
            buttonSelectors.minus.attr('disabled', true);
            buttonSelectors.plus.attr('disabled', false);
        } else if (newFontSizeKey === (fontSizes.length - 1)) {
            // Letztes Array-Element = größte fontsize
            moduleLogger.info('FontSize ist größter Wert: ' + fontSize, fontSizes);
            buttonSelectors.minus.attr('disabled', false);
            buttonSelectors.plus.attr('disabled', true);
        } else {
            // Ansonsten irgendein Array-Element in der Mitte
            buttonSelectors.minus.attr('disabled', false);
            buttonSelectors.plus.attr('disabled', false);
        }

        return true;
    }


    /**
     * Setzt die FontSize auf den Standard (=erstes Element des Arrays) zurück
     * @return {void}
     */
    function resetFontSize() {
        moduleLogger.info('Reset FontSize');
        setCurrentFontSize(fontSizes[0]);
    }

    /**
     * Setzt einen Cookie Wert in "NC_Theme_FontSize"
     * @param value
     */
    function setCookieValue(value) {
        moduleLogger.info('CookieValue gesetzt: ' + value);
        $.cookie('NC_Theme_FontSize', value, {'path': '/'});
    }

    /**
     * Gibt den Cookie Wert für "NC_Theme_FontSize" zurück
     * @return {null|string}
     */
    function getCookieValue() {
        var cookieValue = $.cookie('NC_Theme_FontSize');
        moduleLogger.info('CookieValue: ' + cookieValue);
        return cookieValue;
    }


    /**
     * INITIALISIERUNG
     */

    // Toggler in den SelectorInjection anhängen
    $(selectorInjection).append('<div class="feature__accessibility__font-size-changer-wrapper">' +
        '<button type="button" href="javascript:void(0);" class="' + buttonClasses.minus + '">A-</button>' +
        '<button type="button" href="javascript:void(0);" class="' + buttonClasses.reset + '">A</button>' +
        '<button type="button" href="javascript:void(0);" class="' + buttonClasses.plus + '">A+</button>' +
        '</div>');

    // buttonSelectors mit den Selektoren der Buttons füllen (nach dem Injecten), damit man diese wiederverwenden kann
    buttonSelectors.minus = $('.' + buttonClasses.minus);
    buttonSelectors.reset = $('.' + buttonClasses.reset);
    buttonSelectors.plus = $('.' + buttonClasses.plus);


    // Events registrieren für die Buttons
    buttonSelectors.minus.click(function () {
        decreaseFontSize();
    });
    buttonSelectors.reset.click(function () {
        resetFontSize();
    });
    buttonSelectors.plus.click(function () {
        increaseFontSize();
    });

    // Aktuelle FontSize setzen (aus Cookie oder Standard)
    initCurrentFontSize();


    moduleLogger.info('SCRIPT ENDE');

}
